/** Outcomes an agent can save for a conversation that actually happened. The
 * `key` is what the backend, HubSpot and do-not-call suppression understand
 * (routes/workspace.js validates it); `label` is only what the operator sees.
 * The dialer's own verdicts (HUMAN/MACHINE/NO_ANSWER/…) come from the engine. */
export const OUTCOMES = [
  { key: 'meeting', label: 'Meeting booked', tone: 'good' },
  { key: 'callback', label: 'Follow up' },
  { key: 'meaningful', label: 'Meaningful conversation' },
  { key: 'email', label: 'Send email' },
  { key: 'not_interested', label: 'Not interested' },
  { key: 'bad_data', label: 'Bad data' },
  { key: 'do_not_call', label: 'Do not call' },
];

/** Built-in dispositions, shaped like rows from /api/dispositions — what the
 * notes window offers until (or unless) custom ones load from Supabase. */
export const DEFAULT_DISPOSITIONS = OUTCOMES.map((outcome, index) => ({
  id: `builtin-${outcome.key}`,
  label: outcome.label,
  outcome_key: outcome.key,
  requires_notes: false,
  sort_order: index + 1,
  builtin: true,
}));
